import styles from './StatusPanel.module.css';

export function LoadingPanel() {
  return (
    <div className={styles.panel} role="status" aria-live="polite">
      <div className={styles.label}>Loading dashboard…</div>
    </div>
  );
}

export function ErrorPanel({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className={styles.panel} role="alert">
      <div className={`${styles.label} ${styles.error}`}>Couldn&apos;t load report</div>
      <div className={styles.detail}>{message}</div>
      <button type="button" className={styles.retry} onClick={onRetry}>
        Try again
      </button>
    </div>
  );
}
